import type { TourDefinition } from '../tours.types';

export const AREAS_FIRMA_PLANTILLA_TOUR: TourDefinition = {
  id: 'areas_firma_plantilla_help',
  remember: true,
  steps: [
    {
      element: '[data-tour="areas-firma-root"]',
      popover: {
        title: 'Áreas de firma',
        description:
          'En este paso debes definir dónde se dibujarán las áreas de firma, tanto para firmas grupales como para firmas individuales de los participantes en procesos de firma masiva.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="menu-documentos"]',
      popover: {
        title: 'Documentos a firmar',
        description:
          'Aquí puedes seleccionar los documentos que se van a firmar, previsualizarlos y definir sus respectivas áreas de firma.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="area-seleccion-firmas"]',
      popover: {
        title: 'Previsualización y selección de áreas',
        description:
          'En esta sección puedes previsualizar el documento y seleccionar dónde se colocarán las firmas correspondientes al grupo seleccionado y a los certificados individuales incluidos en la firma masiva.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="selector-tamanios-firmas"]',
      popover: {
        title: 'Tamaño de la firma',
        description:
          'Aquí puedes seleccionar el tamaño que tendrán las firmas dentro de los documentos.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="selector-modo-seleccion"]',
      popover: {
        title: 'Modo de selección de área',
        description:
          'Puedes cambiar el modo en el que seleccionas las áreas de firma. ' +
          'Si esta opción está activa, podrás arrastrar y soltar sobre el documento. ' +
          'Si la desactivas, podrás dibujar el área de forma libre y ajustar manualmente sus proporciones.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="firma-next"]',
      popover: {
        title: 'Continuar',
        description:
          'Cuando hayas definido las áreas de firma, haz clic en “Siguiente” para continuar con el proceso.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
